quoteModule.factory('quoteContractRetrievalService', ['$http','AppSettings','commonRESTCallService', '$q',
    'contractInfoService','contractCreationService','rateQuotePersistService','financeContractService',
function ($http, appSettings, commonRESTCallService, $q,
          contractInfoService,contractCreationService, rateQuotePersistService,financeContractService) {
    var quoteContractRetrievalService = {};

    quoteContractRetrievalService.requiredFieldsMissingError = "Required fields missing";

    quoteContractRetrievalService.initContractsCreated = function(){
        contractCreationService.contractsProcessing.contractsCreated = false;
    }
    quoteContractRetrievalService.getContractsByQuoteIds = function(quoteIds, includeLargeFields){
        if (!angular.isArray(quoteIds))
            throw new Error('quoteIds must be an array');

        var deferred = $q.defer();

        var promises = [];
        var promiseAltFinance = [];

        //contractCreationService.initContractInfo();

        quoteIds.forEach(function buildContractRetrieval(quoteId){
            var pm = commonRESTCallService.getFromServer(appSettings.startSPANPlusSvcURL + "productcontracts/productquote/"
                + rateQuotePersistService.getEncryptedQuoteId(quoteId) + "/?includeall=" + (includeLargeFields ? "Y" : "N"));
            promises.push(pm);
        });

       contractCreationService.contractsProcessing.completedLookup = false;

        var contracts = [];
        $q.all(promises).then(
            function completedRetrievingContracts(allRes) {
                var i=0;
                contractCreationService.initContractInfo();
                allRes.forEach(function setupContractInfoResults(res){
                    if (res && res.data && res.data.itemList && res.data.itemList.length > 0) {
                        contracts = contracts.concat(res.data.itemList);

                        contractCreationService.contractsProcessing.contractsCreated = res.data.itemList.length > 0;

                        res.data.itemList.forEach(function setupContractInfoState(contract){
                            if (!contractInfoService.contractsPerQuote[quoteIds[i]])
                                contractInfoService.contractsPerQuote[quoteIds[i]] = [];
                            var url = appSettings.startSPANPlusSvcURL + "productcontracts/get-pdf/" + contract.contractId;
                            if (contractInfoService.contractsPerQuote[quoteIds[i]].indexOf(url)< 0) {
                                contractInfoService.contractsPerQuote[quoteIds[i]].push(
                                    url
                                );
                            }
                            contractInfoService.contractInfo[url] = {providerContractNumber : contract.providerContractId, formName : contract.constructedFormName, status: contract.contractStatusName, contractId: contract.contractId};
                            contractCreationService.contractsProcessing.officialContractsCreated |= contract.contractStatusName.toUpperCase() == 'OFFICIAL';

                            if (contract.isSpp) {
                                var urlSpp = appSettings.startSPANPlusSvcURL + "productcontracts/get-pdf/" + contract.contractId + '/?type=alt-finance';
                                var j = i;

                                var _altFinancing = commonRESTCallService.getFromServer(urlSpp.toString())
                                    .success(function (responseData) {
                                        financeContractService.getAltFinancingMode()
                                            .then(
                                                function(_financingMode) {
                                                    if (_financingMode == "POST-CONTRACT-MODE") {
                                                        urlSpp = responseData;

                                                        if (contractInfoService.contractsPerQuote[quoteIds[j]].indexOf(urlSpp) < 0) {
                                                            contractInfoService.contractsPerQuote[quoteIds[j]].push(
                                                                urlSpp
                                                            );
                                                        }

                                                        if(!contractInfoService.contractInfo[urlSpp]) {
                                                            contractInfoService.contractInfo[urlSpp] = {
                                                                providerContractNumber: contract.providerContractId.replace('BASE-', 'PYMNT-'),
                                                                formName: 'Payment-Link',
                                                                status: contract.contractStatusName,
                                                                contractId: contract.contractId
                                                                // altPaymentLink: contract.altPaymentLink,
                                                            };
                                                        }

                                                        if (contract.contractStatusName == 'DRAFT') {
                                                            contractInfoService.quoteQueueInfo.bankInfoRequired[quoteIds[j]] = true;//will set up values later

                                                        }
                                                    }
                                                    else {
                                                        if (contractInfoService.contractsPerQuote[quoteIds[j]].indexOf(urlSpp) < 0) {
                                                            contractInfoService.contractsPerQuote[quoteIds[j]].push(
                                                                urlSpp
                                                            );
                                                        }
                                                        contractInfoService.contractInfo[urlSpp] = {
                                                            providerContractNumber: contract.providerContractId.replace('BASE-', 'PYMNT-'),
                                                            formName: 'Payment-Agreement',
                                                            status: contract.contractStatusName
                                                        };

                                                        if (contract.contractStatusName == 'DRAFT') {
                                                            contractInfoService.quoteQueueInfo.bankInfoRequired[quoteIds[j]] = true;//will set up values later

                                                        }
                                                    }

                                                    deferred.resolve(urlSpp);
                                                });
                                    })
                                    .error(function (err) {
                                        deferred.reject(err);
                                    });

                                promiseAltFinance.push(_altFinancing);
                            }
                        });
                    }
                    i = i + 1;
                });
            }
        ).
        then(function(){
            contractCreationService.contractsProcessing.completedLookup = true;
            deferred.resolve(contracts);
        })
        .catch(function(err){
                contractCreationService.contractsProcessing.completedLookup = true;
                deferred.reject(err);
        });
        return deferred.promise;
    };

    return quoteContractRetrievalService;
}]);